export const Icon = 'atlantis-icon';